<template>
    <form action="">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ teamId ? 'Edit' : 'Create' }} Team</p>
            </header>

            <section class="modal-card-body">
                <o-field label="Users">
                    <multicomplete
                            type="user"
                            field-name="full_name"
                            v-model="pickedUsers"
                            placeholder="Select Users"
                            :error="getError('users')"
                    />
                </o-field>

                <o-field label="Name" :type="fieldType('name')" :message="getError('name')">
                    <o-input v-model="copy.name" />
                </o-field>

                <o-field label="Monthly Goal" :type="fieldType('monthly_goal')" :message="getError('monthly_goal')">
                    <o-input v-model="copy.monthly_goal" />
                </o-field>
            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.$parent.$emit('update:active', false)">Close</button>
                <button @click.prevent="handleSubmit" v-submit="submitting" class="button is-primary">Save</button>
            </footer>
        </div>
    </form>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex'
    import HandlesForm from './../../mixins/HandlesForm'
    import Multicomplete from './../../components/Multicomplete'

    export default {
        mixins: [HandlesForm],

        props: ['teamId'],

        components: {
            Multicomplete
        },

        data() {
            return {
                pickedUsers: []
            }
        },

        mounted() {
            if (this.teamId) {
                let team = this.teamById(this.teamId)
                let copy = _.clone(team)

                this.pickedUsers = _.map(copy.users, (userId) => {
                    return this.userById(userId)
                })
                this.copy = copy
            } else {
                this.copy = {
                    name: '',
                    monthly_goal: null,
                    users: []
                }
            }
        },

        methods: {
            ...mapActions(['createOrUpdateTeam']),

            handleSubmit() {
                let submit = this.wrapSubmit(this.createOrUpdateTeam),
                    payload = this.copy

                payload.users = _.map(this.pickedUsers, 'id')

                submit(this.copy)
                    .then(res => {
                        this.successMessage('Team has been successfull saved')
                        this.$parent.$parent.$emit('update:active', false)
                        return res
                    })

            }
        },

        computed: {
            ...mapGetters([
                'users',
                'userById',
                'teamById'
            ]),
        },
    }
</script>
